import React from 'react';
import Loader from 'react-loader-advanced';

export default class LoaderComponent extends React.Component{

    render(){
        const spinner = <span><img src="../../loader.gif" height= "30" width="30"alt=""/></span>
        // console.log(this.props.showLoader)
        return(
            
            <Loader 
                show = {this.props.showLoader} 
                message = {spinner}
                backgroundStyle = {{position:"fixed"}}>
                {this.props.children}
            </Loader>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/cAjaxLoader.js